export const TICKETS_MOUSE_ENTER_DELAY = 600;
